// Core domain types for Synapsios - matches API/MySQL schema

export interface Project {
  id: string
  name: string
  description: string
  icon_color: string
  status: 'active' | 'archived'
  priority: 'low' | 'medium' | 'high'
  tags: string // JSON string of string[]
  thread_count?: number
  folder_count?: number
  last_activity?: string | null
  is_locked?: boolean
  poster_image?: string | null
  created_at: string
  updated_at: string
}

export interface Folder {
  id: string
  project_id: string
  parent_folder_id: string | null
  name: string
  status: 'active' | 'archived'
  order_index: number
  created_at: string
}

export interface Thread {
  id: string
  project_id: string
  folder_id: string | null
  title: string
  description: string
  default_provider: string
  default_model: string
  status: 'active' | 'archived'
  pinned: number
  tags: string // JSON string of string[]
  priority: 'low' | 'medium' | 'high'
  summary: string | null
  thread_category?: string
  message_count?: number
  last_message_at?: string | null
  created_at: string
  updated_at: string
}

export interface Message {
  id: string
  thread_id: string
  role: 'user' | 'assistant' | 'system'
  content: string
  model_used: string | null
  provider_used: string | null
  tokens_estimate: number
  created_at: string
}

export interface Decision {
  id: string
  project_id: string
  thread_id: string | null
  title: string
  content: string
  type: 'decision' | 'finding' | 'requirement'
  created_at: string
}

export interface ProviderConfig {
  id: string
  provider_type: string
  display_name: string
  is_active: number
  has_api_key: boolean
  models_available: string[]
  created_at: string
}

export interface ActivityItem {
  id: string
  role: string
  content: string
  model_used: string
  provider_used: string
  created_at: string
  thread_title: string
  thread_id: string
  project_name: string
  project_id: string
}

export interface ThreadWithMessages extends Thread {
  messages: Message[]
}

export interface User {
  id: string
  email: string
  display_name: string
  role: 'admin' | 'user'
  use_own_keys: number
  created_at: string
}

export interface AuthResponse {
  token: string
  user: User
}

export type ActiveView = 'dashboard' | 'project' | 'thread' | 'settings' | 'wallet' | 'marketplace' | 'admin' | 'api-keys' | 'app-builder' | 'agent' | 'social-agent' | 'content-seo' | 'files'

export interface UserFile {
  id: string
  name: string
  mime_type: string
  size: number
  project_id?: string | null
  folder_id?: string | null
  created_at: string
  updated_at: string
  content?: string
  is_text?: boolean
}

export interface TreeNode {
  id: string
  label: string
  type: 'project' | 'folder' | 'thread'
  projectId?: string
  children: TreeNode[]
}

export function parseTags(tags: string | undefined): string[] {
  if (!tags) return []
  try { return JSON.parse(tags) } catch { return [] }
}
